import {CardTypeEnum} from "../../../types/CardTypeEnum";
import {Modal, Button} from "antd";
import React, {useEffect} from "react";


function IntentApp({providerName = ""}) {
    const [open, setOpen] = React.useState<boolean>(true);

    const setIntentApp = () => {
        setTimeout(() => {
            handlePayment(providerName);
        }, 2000);
    };

    const clickModal = () => {
        setOpen(false);
    }

    useEffect(() => {
        if (open) {
            setIntentApp();
        }
    }, []);

    const callEasypaisa = () => {
        const intentUrl = "intent://easypaisa.onelink.me/miniapp#Intent;scheme=https;package=pk.com.telenor.phoenix;end";
        window.location.href = intentUrl;
    };

    const callJazzcash = () => {
        const intentUrl = "intent://deeplink#Intent;scheme=jazzcash;package=com.techlogix.mobilinkcustomer;end";
        window.location.href = intentUrl;
    };

    const handlePayment = (providerName: string | string[]) => {
        if (providerName === CardTypeEnum.EasyPaisa) {
            console.log('[IntentApp] : Easypaisa')
            callEasypaisa();
        }
        if (providerName === CardTypeEnum.JazzCash || providerName === CardTypeEnum.JazzCashV2) {
            callJazzcash();
            console.log('[IntentApp] : Jazzcash')
        }
    };

    return (
        <>
            <Modal
                title={" "}
                footer={
                    <Button type="primary" onClick={clickModal}>
                        OK
                    </Button>
                }
                open={open}
                onCancel={() => setOpen(false)}
                width={500}
                bodyStyle={{
                    height: "200px"
                }}
            >
                <div style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#1B1B1B",
                    textAlign: "left"
                }}>
                    Please wait patiently. <br/>
                    You will be redirected to the wallet app shortly, or you can log in Wallet to complete the payment.
                </div>
                <br/>
                <hr/>
                <br/>
                <div style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#878787",
                    textAlign: "right",
                    direction: "rtl"
                }}>
                    براہ کرم انتظار کریں۔ آپ کو آٹومیٹکلی والیٹ JAZZCASH/EASYPAISA پر بھیج دیا جائے گا۔یا آپ خود ادائیگی کرنے کے لیے والیٹ ایپ میں لاگ ان کر سکتے ہیں۔
                </div>
            </Modal>
        </>
    )
}

export default IntentApp;
